// List of properties that get passed to the popup Window
export const POPUP_WINDOW_PROPS =
  "width=500,height=700,resizable,scrollbars,status,location";
